import { defineComponent as _defineComponent } from 'vue'
import ExternalLink from '@/components/svg/external-link.svg?inline';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CertificateEducationItem',
  props: {
  title: {
    type: String,
    default: '',
  },
  origin: {
    type: String,
    default: '',
  },
  year: {
    type: Number,
    default: null,
  },
  link: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;



const displayYear = computed(() => (props.year && props.year > 0 ? props.year : ''));

return { __sfc: true,props, displayYear, ExternalLink }
}

})